import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import angularGettext from 'angular-gettext';
import usersListPageDirective from './UsersListPageDirective'
import usersAddPageDirective from './UsersAddPageDirective'
import usersEditPageDirective from './UsersEditPageDirective'

let usersModule = angular.module('cms.pages.users', [
    uiRouter,
    angularGettext,
    usersListPageDirective,
    usersAddPageDirective,
    usersEditPageDirective
])
    .config(routeConfig);

function routeConfig($stateProvider,gettext) {
    /** @ngInject */

    $stateProvider
        .state('users', {
            url: '/users?firstName&lastName&email&order_by&order_direction&page',
            component: 'appUsersList',
            title: gettext('Users'),
            data: {
                requiresAuth: ['ROLE_ADMIN']
            },
            reloadOnSearch: false,
            sidebarMeta: {
                icon: 'ion-person',
                order: 0,
                allow: ['ROLE_ADMIN']
            }
        })
        .state('usersAdd', {
            url: '/users/add',
            component: 'appUsersAdd',
            title: gettext('Add User'),
            data: {
                requiresAuth: ['ROLE_ADMIN']
            },
            params: {
                returnState: null
            },
            breadcrumbsMeta: {
                parentState: 'users'
            }
        })
        .state('usersEdit', {
            url: '/users/edit/:id',
            component: 'appUsersEdit',
            params: {
                returnState: null
            },
            title: gettext('Edit user'),
            data: {
                requiresAuth: ['ROLE_ADMIN']
            },
            breadcrumbsMeta: {
                parentState: 'users'
            }
        })
    ;
}

export default usersModule.name;


// WEBPACK FOOTER //
// ./src/cmsPages/Users/Users.js